export default __webpack_public_path__ + "static/media/result-not-found.388a9b58.png";